module.exports = __webpack_public_path__ + "img/arroba.080c8a87.svg";